import React from 'react';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Chip,
    Divider,
    Stack,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';

import { MONTHS, QUARTERS } from './evaluationConstants';

export default function EvaluationSidebarCard({
    selectedMode,
    year,
    month,
    quarter,
    loading,
    onModeChange,
    onYearChange,
    onMonthChange,
    onQuarterChange,
    onRun,
}) {
    return (
        <Card
            data-evaluation-sidebar="true"
            sx={{ borderRadius: 3, boxShadow: '0 6px 24px rgba(0,0,0,0.06)', height: '100%' }}
        >
            <CardHeader title="Auswertung" subheader="Gleiche Optik für alle Steuerarten" sx={{ pb: 0 }} />
            <CardContent>
                <ToggleButtonGroup
                    exclusive
                    value={selectedMode}
                    onChange={(_, value) => {
                        if (value) onModeChange(value);
                    }}
                    size="small"
                    sx={{ mb: 2, flexWrap: 'wrap' }}
                >
                    <ToggleButton value="ust-month">USt-Voranmeldung (Monat)</ToggleButton>
                    <ToggleButton value="ust-quarter">USt-Voranmeldung (Quartal)</ToggleButton>
                    <ToggleButton value="ust-annual">USt-Jahreserklaerung</ToggleButton>
                    <ToggleButton value="est-month">Einkommensteuer (Monat)</ToggleButton>
                    <ToggleButton value="est-quarter">Einkommensteuer (Quartal)</ToggleButton>
                    <ToggleButton value="est-annual">Einkommensteuer (Jahr)</ToggleButton>
                </ToggleButtonGroup>

                <Stack direction={{ xs: 'column', sm: 'row' }} gap={2} sx={{ mb: 2 }}>
                    <TextField
                        label="Jahr"
                        value={year}
                        onChange={(event) => onYearChange(event.target.value)}
                        type="number"
                        size="small"
                        sx={{ minWidth: 120 }}
                    />
                    {(selectedMode === 'ust-month' || selectedMode === 'est-month') && (
                        <TextField
                            label="Monat"
                            value={month}
                            onChange={(event) => onMonthChange(event.target.value)}
                            size="small"
                            select
                            sx={{ minWidth: 180 }}
                            SelectProps={{ native: true }}
                        >
                            <option value="" disabled>
                                Bitte wählen
                            </option>
                            {MONTHS.map((label, index) => (
                                <option key={index + 1} value={index + 1}>
                                    {label}
                                </option>
                            ))}
                        </TextField>
                    )}
                    {(selectedMode === 'ust-quarter' || selectedMode === 'est-quarter') && (
                        <TextField
                            label="Quartal"
                            value={quarter}
                            onChange={(event) => onQuarterChange(event.target.value)}
                            size="small"
                            select
                            sx={{ minWidth: 180 }}
                            SelectProps={{ native: true }}
                        >
                            <option value="" disabled>
                                Bitte wählen
                            </option>
                            {QUARTERS.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label} ({item.monthRange})
                                </option>
                            ))}
                        </TextField>
                    )}
                </Stack>

                <Button
                    fullWidth
                    variant="contained"
                    disabled={loading}
                    onClick={onRun}
                    sx={{
                        backgroundColor: 'orange',
                        '&:hover': { backgroundColor: '#cc7a00' },
                        borderRadius: 2,
                        py: 1.1,
                        color: '#000',
                        fontWeight: 700,
                    }}
                >
                    Auswertung starten
                </Button>

                {loading && <Chip label="In Arbeit…" color="warning" size="small" sx={{ mt: 1 }} />}
            </CardContent>
            <Divider />
            <CardContent>
                <Typography variant="body2" color="text.secondary">
                    Wähle Jahr und Auswertungstyp. Monat oder Quartal kannst du für Umsatzsteuer und Einkommensteuer verwenden. Mit
                    "Neu berechnen" aktualisierst du die zuletzt angezeigte Ansicht.
                </Typography>
            </CardContent>
        </Card>
    );
}
